import { dictionary } from '@/config/language/dictionary';
import { error404 } from '@/config/language/error404';
import { member } from '@/config/language/member';
import { semantics } from '@/config/language/semantics';
import { service } from '@/config/language/service';

import { alert } from './alert';
import { common } from './common';
import { dashboard } from './dashboard';
import { detailCode } from './detailCode';
import { device } from './device';
import { distributor } from './distributor';
import { filter } from './filter';
import { functions } from './function';
import { groupCode } from './groupCode';
import { ingestMonitor } from './ingestMonitor';
import { license } from './license';
import { log } from './log';
import { manifest } from './manifest';
import { menu } from './menu';
import { order } from './order';
import { organization } from './organization';
import { pageStatus } from './pageStatus';
import { patient } from './patient';
import { resource } from './resource';
import { role } from './role';
import { rules } from './rules';
import { servers } from './servers';
import { settings } from './settings';
import { sysSetting } from './syssetting';
import { tag } from './tag';
import { user } from './user';

const languageData = {
  common,
  dashboard,
  detailCode,
  device,
  organization,
  functions,
  groupCode,
  menu,
  manifest,
  pageStatus,
  patient,
  resource,
  alert,
  role,
  rules,
  settings,
  tag,
  user,
  dictionary,
  semantics,
  member,
  error404,
  service,
  filter,
  log,
  sysSetting,
  distributor,
  servers,
  license,
  order,
  ingestMonitor,
};

export default languageData;
